export const REPRESENTATION = {
  directMailMe: 'Direct mail',
  emailMe: 'Email',
  callMe: 'Call',
  textMe: 'SMS'
}
